var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderNav',[_c('img',{staticClass:"logo-light",attrs:{"slot":"logo","src":_vm.logoLight},slot:"logo"}),_c('img',{staticClass:"logo-dark",attrs:{"slot":"logo-dark","src":_vm.logoDark},slot:"logo-dark"})]),_c('Slider')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }